// extracted by mini-css-extract-plugin
module.exports = {"date":"TodaysDate_date__2lvC7"};